import React from "react"
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from "react-icons/md"

export interface RadioOption {
  value: string
  label?: string
}

export interface RadioGroupProps {
  options: RadioOption[] // Array of options for the radio group
  selectedValue: string // The currently selected value
  onChange: (value: string) => void // Callback when a value is selected
  className?: string // Optional custom class for the container
  buttonClassName?: string // Optional custom class for the buttons
  selectedButtonClassName?: string // Optional custom class for the selected button
}

const RadioButton = ({ value, selectedValue, onChange }) => {
  return (
    <div
      className={`flex items-center space-x-2 cursor-pointer  `}
      onClick={() => onChange(value)}
    >
      {selectedValue === value ? (
        <MdRadioButtonChecked color="white" />
      ) : (
        <MdRadioButtonUnchecked color="#C2C2C2AA" />
      )}
      <span className="text-md text-white font-regular">{value}</span>
    </div>
  )
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  options,
  selectedValue,
  onChange,
  className = "",
}) => {
  return (
    <div className={`grid grid-cols-1 ${className}`}>
      {options.map((item, index) => {
        return (
          <>
            <RadioButton
              key={index}
              value={item.value}
              selectedValue={selectedValue}
              onChange={onChange}
            />

            {options[index + 1] && (
              <div className="h-[1px] w-full bg-white/20"></div>
            )}
          </>
        )
      })}
    </div>
  )
}

export default RadioGroup
